var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-content',[_c('loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.loader),expression:"loader"}],attrs:{"object":"#29B3A6","color1":"#29B3A6","color2":"#17fd3d","size":"4","speed":"2","bg":"#343a40","objectbg":"#999793","opacity":"80","name":"spinning"}}),_c('Blank')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }